import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AbstractWidgetComponent, ContextChange, DialogService, ResponseMessage, ResponseStatus, WidgetStyle } from '@sdbn/common';
import { EditorBlacklistDetails } from '../blacklist-administration.model';
import { BlacklistAdministrationService } from '../blacklist-administration.service';

@Component({
    selector: 'app-blacklist-administration',
    templateUrl: './blacklist-administration.component.html',
    styleUrls: ['./blacklist-administration.component.scss'],
    standalone: false
})
export class BlacklistAdministrationComponent extends AbstractWidgetComponent {

  responseMessages: ResponseMessage[];

  loading = false;
  dirty = false;
  valid = false;

  // @ViewChild(MatSort) sort: MatSort;
  sortDirection = 'asc';
  sortColumn = 'company';
  columnsToDisplay = [
    'company', 'name', 'firstname', 'numberPlate', 'note', 'btn'
  ];

  blacklistDetails = new Array<EditorBlacklistDetails>();
  dataSource: MatTableDataSource<EditorBlacklistDetails> = new MatTableDataSource(new Array<EditorBlacklistDetails>());
  selection = new SelectionModel<EditorBlacklistDetails>();

  constructor(
    private dialogService: DialogService,
    private blacklistAdministrationService: BlacklistAdministrationService
  ) {
    super();
    this.loadBlacklist();
  }

  onContextChange(contextChange: ContextChange) {
  }

  onSetElementAndContext() {
  }

  public toggleSelection(details: EditorBlacklistDetails) {

    this.blacklistDetails.forEach(b => b.selected = false);

    if (details !== this.selection.selected[0]) {
      details.selected = true;
      this.selection.toggle(details);
    }
  }

  public blacklistDetailsChanged(details: EditorBlacklistDetails) {
    details.dirty = true;
    this.updateViewModel();
  }

  public save() {
    this.loading = true;
    this.responseMessages = [];

    const changedDetails = this.blacklistDetails.filter(b => b.dirty);
    this.blacklistAdministrationService.saveBlacklist(changedDetails).subscribe(
      result => {
        if (result.status === ResponseStatus.FAILED) {
          this.responseMessages = result.responseMessages;
        } else {
          this.loadBlacklist();
        }
        this.loading = false;
      }, error => {
        this.loading = false;
      }
    );
  }

  public addDetails() {
    const newEntry = new EditorBlacklistDetails();
    newEntry.dirty = true;
    this.blacklistDetails.push(newEntry);
    this.dataSource.data = this.blacklistDetails.filter(d => !d.deleted);
    this.toggleSelection(newEntry);
    this.updateViewModel();
  }

  public cancel() {

    this.dialogService.showConfirm('tmc-yard.widgets.blacklist-administration.cancel.confirm-dialog.title',
      'tmc-yard.widgets.blacklist-administration.cancel.confirm-dialog.message').afterClosed().subscribe(confirm => {
        if (confirm) {
          this.selection.clear();
          this.loadBlacklist();
        }
      });

  }

  public delete(details: EditorBlacklistDetails) {

    this.dialogService.showConfirm('tmc-yard.widgets.blacklist-administration.delete.confirm-dialog.title',
      'tmc-yard.widgets.blacklist-administration.delete.confirm-dialog.message').afterClosed().subscribe(confirm => {
        if (confirm) {
          details.dirty = true;
          if (details.id != null) {
            details.deleted = true;
          } else {
            this.blacklistDetails.splice(this.blacklistDetails.indexOf(details), 1);
          }
          this.updateViewModel();
          this.dataSource.data = this.blacklistDetails.filter(d => !d.deleted);
        }
      });

  }

  private loadBlacklist() {
    this.loading = true;
    this.responseMessages = [];

    this.blacklistAdministrationService.loadBlacklist().subscribe(
      result => {
        this.blacklistDetails = new Array<EditorBlacklistDetails>();
        result.forEach(r => {
          this.blacklistDetails.push(new EditorBlacklistDetails(r));
        });
        this.dataSource.data = this.blacklistDetails;
        this.updateViewModel();
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
  }

  private updateViewModel() {
    let valid = true;
    let dirty = false;
    this.blacklistDetails.forEach(
      b => {
        b.valid = (b.company != null && b.company.length > 0) ||
          (b.name != null && b.name.length > 0) ||
          (b.firstname != null && b.firstname.length > 0) ||
          (b.numberPlate != null && b.numberPlate.length > 0);

        if (!b.valid) {
          valid = false;
        }
        if (b.dirty) {
          dirty = true;
        }
      }
    );
    this.valid = valid;
    this.dirty = dirty;
  }

  getStyle(): WidgetStyle {
    return WidgetStyle.transparent;
  }
}
